import { useMutation } from 'react-query'

import { submitToSkat } from '../query-api'
import { SkatError, SkatResponse } from '../types/skatApi'

interface UseSubmitToSkatProps {
  onError?: (error?: SkatError) => void
  onSuccess?: (response: SkatResponse) => void
}

export const useSubmitDeclarationToSkat = (props?: UseSubmitToSkatProps) => {
  const { onError, onSuccess } = props || {}

  const { mutate: submitDeclarationToSkat, ...rest } = useMutation(submitToSkat, {
    onError,
    onSuccess: (response) => {
      onSuccess?.(response)
    },
  })

  return { submitDeclarationToSkat, ...rest }
}
